<template>
  <div>
    <viewTable
        ref="viewTable"
        :limits="limits"
        :columns-property="columnsProperty"
        :filter="filter"
        module="basic"
        url="purchaseRecords"
        :table-select="false"
        @addOrEdit="addEditHandle"
        @delete="deleteHandle"
        @reset="resetHandle">
      <template slot="adSearch">
        <el-form :inline="true" :model="filter" @keyup.enter.native="loadData(1)">
          <el-form-item label="编号">
            <el-input v-model.trim="filter.no" placeholder="请输入采购记录编号" clearable/>
          </el-form-item>
          <el-form-item label="供应商编号">
            <el-input v-model.trim="filter.supplierNo" placeholder="请输入供应商编号" clearable/>
          </el-form-item>
          <el-form-item label="供应商名称">
            <el-input v-model.trim="filter.supplierName" placeholder="请输入供应商名称" clearable/>
          </el-form-item>
          <el-form-item label="物料编号">
            <el-input v-model.trim="filter.materialNo" placeholder="请输入物料编号" clearable/>
          </el-form-item>
          <el-form-item label="物料名称">
            <el-input v-model.trim="filter.materialName" placeholder="请输入物料名称" clearable/>
          </el-form-item>
        </el-form>
      </template>
    </viewTable>
    <purchase-info-record-edit ref="purchaseInfoRecordEdit" @save-success="loadData"/>
  </div>
</template>

<script>
  import viewTable from "@/components/ViewTable.vue";
  import PurchaseInfoRecordEdit from "./PurchaseInfoRecordEdit.vue";
  export default {
    name: "PurchaseInfoRecordList",
    components: { viewTable, PurchaseInfoRecordEdit },
    data() {
      return {
        limits: {
          addAuth: this.$auth(804),
          editAuth: this.$auth(802),
          delAuth: this.$auth(803),
        },
        filter: {
          no: "",
        },
        columnsProperty: [
          {
            width: 55,
            align: "center",
            type: "expand",
            render: (h, params) => {
              return h("Table", {
                props: {
                  data: params.row.details,
                  columns: [
                    {
                      type: "index",
                      width: 55,
                      align: "center",
                    },
                    {
                      title: "物料编号",
                      key: "materialNo",
                      width: 160,
                    },
                    {
                      title: "物料名称",
                      key: "materialName",
                      minWidth: 300,
                    },
                    {
                      title: "单位",
                      key: "unitName",
                      width: 80,
                      align: "center",
                    },
                    {
                      title: "提交天数",
                      key: "planDeliveryDate",
                      width: 110,
                      align: "center",
                    },
                    {
                      title: "含税价",
                      key: "taxPrice",
                      width: 80,
                      align: "center",
                    },
                    {
                      title: "备注",
                      key: "note",
                      width: 240,
                      align: "center",
                      tooltip:true,
                    },
                  ],
                  border: true,
                  stripe: true,
                },
              });
            },
          },
          {
            key: "no",
            align: "center",
            width: 150,
            render: (h, params) => {
              return h(
                "span",
                {
                  style: {
                    color: "#2d8cf0",
                    cursor: "pointer",
                  },
                  on: {
                    click: () => {
                      this.$refs.purchaseInfoRecordEdit.open(params.row, true);
                    },
                  },
                },
                params.row.no
              );
            },
          },
          {
            key: "supplierNo",
            align: "center",
            width: 120,
          },
          {
            key: "supplierName",
            width: 280,
            tooltip: true,
          },
          {
            key: "note",
            width: 240,
            tooltip: true,
          },
          {
            key: "creatorName",
            width: 100,
            align: "center",
          },
          {
            key: "action",
            align: "center",
            width: 140,
            slot: "action",
          },
        ],
      };
    },
    methods: {
      addEditHandle(row) {
        this.$refs.purchaseInfoRecordEdit.open(row);
      },

      loadData(pageNum) {
        this.$refs.viewTable.loadData(pageNum);
      },

      deleteHandle(row) {
        this.$http.delete("basic", "purchaseRecords", row.pkid).then((resp) => {
          if (resp.success) {
            this.loadData();
            this.$message.success("删除成功");
          }
        });
      },

      resetHandle(filter) {
        this.filter = Object.assign(this.filter, filter);
      },
    },
  };
</script>
